import { useState } from "react";
import { useAuthContext } from "@/hooks/useAuthContext";
import { useGetAccountByIdQuery } from "@/redux/api/accounts.rtkq";
import { useUpdateOfficeSettingsMutation } from "@/redux/api/offices.rtkq";

const OfficeSettingsPage = () => {
  const { getAccountId } = useAuthContext();
  const officeId = getAccountId() || "";
  const { data: account } = useGetAccountByIdQuery(
    { accountId: officeId },
    { skip: !officeId }
  );
  const [updateSettings] = useUpdateOfficeSettingsMutation();

  const [name, setName] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [city, setCity] = useState("");
  const [saved, setSaved] = useState(false);

  // Populate form when data loads
  useState(() => {
    if (account) {
      setName(account.name || "");
      setBusinessName(account.accountInformation?.businessName || "");
      setPhoneNumber(account.accountInformation?.phoneNumber || "");
      setCity(account.accountInformation?.city || "");
    }
  });

  const handleSave = async () => {
    try {
      await updateSettings({
        officeId,
        name: name || undefined,
        accountInformation: { businessName, phoneNumber, city },
      }).unwrap();
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (err: any) {
      alert(err.data?.message || "שגיאה בעדכון ההגדרות");
    }
  };

  return (
    <div className="container mx-auto p-6 max-w-2xl" dir="rtl">
      <h1 className="text-2xl font-bold text-foreground mb-6">הגדרות משרד</h1>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-1">שם המשרד</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-3 py-2 border border-border rounded-lg bg-background text-foreground"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-1">שם העסק</label>
          <input
            type="text"
            value={businessName}
            onChange={(e) => setBusinessName(e.target.value)}
            className="w-full px-3 py-2 border border-border rounded-lg bg-background text-foreground"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-1">מספר טלפון</label>
          <input
            type="tel"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            className="w-full px-3 py-2 border border-border rounded-lg bg-background text-foreground"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-1">עיר</label>
          <input
            type="text"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            className="w-full px-3 py-2 border border-border rounded-lg bg-background text-foreground"
          />
        </div>

        <div className="pt-4 border-t border-border">
          <h2 className="text-lg font-semibold mb-2">מנוי</h2>
          <div className="text-muted-foreground">
            <p>סטטוס: <span className="text-foreground font-medium capitalize">{account?.subscription?.status || "—"}</span></p>
            <p>תוכנית: <span className="text-foreground font-medium">{account?.subscription?.plan?.name || "—"}</span></p>
            <p>קרדיטים: <span className="text-foreground font-medium">{account?.creditBalance || 0}</span></p>
          </div>
        </div>

        <button
          onClick={handleSave}
          className="px-6 py-2 bg-chen-900 text-white rounded-lg hover:opacity-90"
        >
          {saved ? "נשמר!" : "שמור שינויים"}
        </button>
      </div>
    </div>
  );
};

export default OfficeSettingsPage;
